// extracted by mini-css-extract-plugin
export default {"sm":"spinner_sm__skz2+","md":"spinner_md__5LwfN","lg":"spinner_lg__ff+zf"};